import React from "react";
import { Plus } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function AddLaneButton({ onClick }) {
  const { t } = useTranslation();
  return (
    <div
      className="flex items-center gap-1.5 px-3 py-2 mt-1.5 cursor-pointer text-sm text-gray-500 hover:text-blue-600 transition-colors whitespace-nowrap"
      onClick={onClick}
    >
      <Plus className="w-4 h-4" />
      <span>{t("Add Column")}</span>
    </div>
  );
}
